import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import ReactionsComments from 'hb-react/shared/components/DesignSystem/Reactions/ReactionsComments';
import ReactionsLikes from 'hb-react/shared/components/DesignSystem/Reactions/ReactionsLikes';
import ReactionsShares from 'hb-react/shared/components/DesignSystem/Reactions/ReactionsShares';

const FileThumbnailReactions = ({ comments, likes, shares, ...rest }) => (
  <Box mx={4}>
    {likes && (
      <ReactionsLikes
        {...rest}
        {...likes}
        key={`likes-${likes.initialLikes.count}`}
      />
    )}
    {comments && (
      <ReactionsComments
        {...rest}
        {...comments}
        key={`comments-${comments.totalComments}`}
      />
    )}
    {shares && <ReactionsShares {...rest} {...shares} />}
  </Box>
);

FileThumbnailReactions.propTypes = {
  comments: PropTypes.object,
  likes: PropTypes.object,
  shares: PropTypes.object,
};

export default FileThumbnailReactions;
